export const PendantList = [
  {
    name: '页面',
    cmpType: 'pageManage',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_tool',
    iconType: 'svg'
  },
  // {
  //   name: '单页',
  //   cmpType: 'addSpa',
  //   icon: '',
  //   edit_type: '',
  //   isShow: true,
  //   position:'left_tool',
  //   iconType: 'svg',
  // },
  {
    name: '模板',
    cmpType: 'template',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_tool',
    iconType: 'svg'
  },
  {
    name: '文字',
    cmpType: 'text',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_tool'
  },
  {
    name: '元素',
    cmpType: 'shape',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_tool'
  },
  {
    name: '图片',
    cmpType: 'image',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_tool'
  },
  {
    name: '区块',
    cmpType: 'block',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_tool'
  },
  // {
  //   name: "组件",
  //   cmpType: "interactive",
  //   icon:'',
  //   edit_type:"",
  //   isShow:true,
  //   position:'left_tool',
  // },
  {
    name: '图文',
    cmpType: 'material',
    icon: '',
    edit_type: '',
    isShow: false,
    position: 'left_tool',
    isComponent: true,
    componentType: 'material',
    iconType: 'svg'
  },
  {
    name: '音乐',
    cmpType: 'music',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_tool'
  },
  {
    name: '视频',
    cmpType: 'video',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_tool'
  },
  {
    name: '变量',
    cmpType: 'variable',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_tool',
    iconType: 'svg'
  },
  {
    name: '输入框',
    cmpType: 'ginput',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_form',
    isComponent: true,
    componentType: 'form'
  },
  {
    name: '报名',
    cmpType: 'sign_up',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_form',
    isComponent: true,
    componentType: 'form'
  },
  {
    name: '单选',
    cmpType: 'gchoose',
    answertype: 'radio', // 都是确保都是gchoose的情况下，区别单选还是多选
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_form',
    isComponent: true,
    componentType: 'form'
  },
  {
    name: '多选',
    cmpType: 'gchoose',
    answertype: 'checkbox', // 都是确保都是gchoose的情况下，区别单选还是多选
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_form',
    isComponent: true,
    componentType: 'form'
  },
  {
    name: '下拉列表',
    cmpType: 'gselect',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_form',
    isComponent: true,
    componentType: 'form'
  },
  {
    name: '提交/签到',
    cmpType: 'gsubmit',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_form',
    isComponent: true,
    componentType: 'form'
  },
  {
    name: '跳转链接',
    cmpType: 'btn',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_action',
    isComponent: true,
    componentType: 'action'
  },
  {
    name: '地图',
    cmpType: 'map',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_action',
    isComponent: true,
    componentType: 'action'
  },
  {
    name: '点赞',
    cmpType: 'praise',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_action',
    isComponent: true,
    componentType: 'action'
  },
  {
    name: '拨打电话',
    cmpType: 'onecall',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_action',
    isComponent: true,
    componentType: 'action'
  },
  {
    name: '留言',
    cmpType: 'bless',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_action',
    isComponent: true,
    componentType: 'action'
  },
  {
    name: '倒计时',
    cmpType: 'countdown',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_form',
    isComponent: true,
    componentType: 'action'
  },
  {
    name: '实时日期',
    cmpType: 'date',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_form',
    isComponent: true,
    componentType: 'action'
  },
  {
    name: '默认表单',
    cmpType: 'form',
    icon: '',
    edit_type: '',
    isShow: false,
    position: '',
    isComponent: true,
    componentType: ''
  },
  {
    name: '大转盘',
    cmpType: 'dial',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_form',
    isComponent: true,
    componentType: 'interaction'
  },
  {
    name: '九宫格',
    cmpType: 'grid',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_form',
    isComponent: true,
    componentType: 'interaction'
  },
  {
    name: '砸金蛋',
    cmpType: 'goldenEgg',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_form',
    isComponent: true,
    componentType: 'interaction'
  },
  {
    name: '大转盘',
    cmpType: 'dialNew',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_form',
    isComponent: true,
    componentType: 'interaction'
  },
  {
    name: '九宫格',
    cmpType: 'gridNew',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_form',
    isComponent: true,
    componentType: 'interaction'
  },
  {
    name: '砸金蛋',
    cmpType: 'goldenEggNew',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_form',
    isComponent: true,
    componentType: 'interaction'
  },
  {
    name: '孔明灯',
    cmpType: 'lantern',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_form',
    isComponent: true,
    componentType: 'interaction'
  },
  {
    name: '微信头像',
    cmpType: 'avatar',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_form',
    isComponent: true,
    componentType: 'effector'
  },
  {
    name: '微信群聊',
    cmpType: 'chat',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_form',
    isComponent: true,
    componentType: 'effector'
  },
  {
    name: '二维码',
    cmpType: 'qrcode',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_form',
    isComponent: true,
    componentType: 'effector'
  },
  {
    name: '锁屏通知',
    cmpType: 'lock',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_form',
    isComponent: true,
    componentType: 'effector'
  },
  {
    name: '指纹开屏',
    cmpType: 'fingerprint',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_form',
    isComponent: true,
    componentType: 'effector'
  },
  {
    name: '擦一擦',
    cmpType: 'wipe',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_form',
    isComponent: true,
    componentType: 'effector'
  },
  {
    name: '组图',
    cmpType: 'pictures',
    icon: '',
    edit_type: '',
    isShow: true,
    position: 'left_form',
    isComponent: true,
    componentType: 'effector'
  }
]

// 数组转成对象
const PObj = {}
PendantList.map(item => {
  PObj[item.cmpType] = {}
  for (const key in item) {
    PObj[item.cmpType][key] = item[key]
  }
})
// console.log(PObj)
export const PendantObj = PObj
